//Reducer Types
interface State {
  salesCommissionData: any;
  salesCommissionCount: number;
  salesClientList: any;
  salesCommissionGroupBySalesPersonData: any;
  salesCommissionGroupBySalesPersonCount: number;
}

export const salesCommissionReducer = (
  state: State = {
    salesCommissionData: [],
    salesCommissionCount: 0,
    salesClientList: [],
    salesCommissionGroupBySalesPersonData: [],
    salesCommissionGroupBySalesPersonCount: 0,
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_SALES_COMMISSION_LIST":
      return {
        ...state,
        salesCommissionData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.salesCommissionData, ...action.payload?.data],
        salesCommissionCount: action.payload.count,
      };
    case "GET_SALES_COMMISSION_CLIENT_LIST":
      return {
        ...state,
        salesClientList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.salesClientList, ...action.payload?.data],
      };

    case "UPDATE_SALES_COMMISSION_DATA":
      return {
        ...state,
        salesCommissionData: state?.salesCommissionData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_SALES_COMMISSION":
      return {
        ...state,
        salesCommissionData: state?.salesCommissionData?.filter(
          (elem: any) => elem?._id !== action?.payload,
        ),
        salesCommissionCount: state?.salesCommissionCount - 1,
      };
    case "GET_SALES_COMMISSION_GROUP_BY_SALES_PERSON_LIST":
      return {
        ...state,
        salesCommissionGroupBySalesPersonData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [
                ...state?.salesCommissionGroupBySalesPersonData,
                ...action.payload?.data,
              ],
        salesCommissionGroupBySalesPersonCount: action.payload.count,
      };
    default:
      return state;
  }
};
